import { Injectable } from '@angular/core';
import { ProductGQL, ProductVariantListGQL } from '../gql/generated';
import { LoaderService } from './loader.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(
    private productVariantListGQL: ProductVariantListGQL,
    private productGQL: ProductGQL,
    private loaderService: LoaderService
  ) { }

  fetchProductVariant(productId: string, productVariantId: string) {
    return this.loaderService.withLoader(() => this.productVariantListGQL.fetch(
      {
        productId: productId,
        options: {
          filter: {
            id: {
              eq: productVariantId
            }
          }
        }
      },
      {
        context: {
          headers: {
            'vendure-token': 'K7',
          },
        },
        fetchPolicy: 'network-only',
      }
    ).pipe(
      map(result => {
        // Find the product variant from the result
        return result.data.product?.variantList.items.find((item) => {
          return item.id === productVariantId
        })
      })
    ), ProductService.name);
  }
  
  fetchProductCustomFields(productId: string, productVariantId: string) {
    return this.loaderService.withLoader(() => this.productVariantListGQL.fetch(
      {
        productId: productId,
        options: {
          filter: {
            id: {
              eq: productVariantId
            }
          }
        }
      },
      {
        context: {
          headers: {
            'vendure-token': 'K7',
          },
        },
        fetchPolicy: 'network-only',
      }
    ).pipe(
      map(result => {
        // Find the product variant from the result
        return result.data.product?.variantList.items.find((item) => {
          return item.id === productVariantId
        })
      })
    ), ProductService.name);
  }

  /**
   * Fetches a product by slug
   * @param slug The product slug
   * @returns Observable with the product data
   */
  fetchProduct(slug: string) {
    return this.loaderService.withLoader(() => this.productGQL.fetch(
      {
        slug: slug
      },
      {
        context: {
          headers: {
            'vendure-token': 'K7',
          },
        },
        fetchPolicy: 'network-only',
      }
    ).pipe(
      map(result => {
        return result.data.product
      })
    ), ProductService.name);
  }
  
  /**
   * Fetches all product variants for a product by productId
   * @param productId The product ID
   * @returns Observable with the product variants
   */
  fetchProductVariants(productId: string) {
    return this.loaderService.withLoader(() => this.productVariantListGQL.fetch(
      {
        productId: productId,
        options: {}
      },
      {
        context: {
          headers: {
            'vendure-token': 'K7',
          },
        },
        fetchPolicy: 'network-only',
      }
    ).pipe(
      map(result => {
        return result.data.product?.variantList.items || []
      })
    ), ProductService.name);
  }
}
